(function () {
    'use strict';
    var m = angular.module('configuration');
    m.factory('apAvananExceptionsParams', ["modals", "$q", "apAvananExceptionsDao", "feature", "brandInfo", function (modals, $q, apAvananExceptionsDao, feature, brandInfo) {
        var apAvananExceptionsParams = {
            addDialogForAllType: function (addParams, title) {
                var modalTitle = title ? title : 'Create Allow-List Rule';
                addParams = addParams || {};
                var modalParams = [
                    {
                        id: 'emails',
                        type: addParams.type === 'edit' ? 'string' : 'list',
                        label: 'Emails'
                    },
                    {
                        id: 'ips',
                        type: addParams.type === 'edit' ? 'string' : 'list',
                        label: 'IPs',
                        settings: {
                            errTipContent: 'Not valid IP',
                            parentElement: addParams.type === 'edit' ? '.param-control' : '.form-inline',
                            successTipContent: addParams.type === 'edit' ? 'Valid IP' : 'Valid IP (Press Space key to complete.)',
                            validation: true,
                            validationType: 'ip',
                            validationOnTyping: true,
                            placeholder: 'Type and press space'
                        },
                        tooltip: 'A valid IP can be in <strong>IPv4</strong> or <strong>IPv6</strong> format. <strong>IPv4</strong> contains ' + 'four numbers (0-255) separated by periods (ex: 1.2.3.4). You may also specify a subnet (ex: 1.2.3.4/32). ' + '<strong>IPv6</strong> contains eight groups of four hexadecimal digits, each group representing 16 bits ' + '(ex:2001:0db8:85a3:0000:0000:8a2e:0370:7334)'
                    },
                    {
                        id: 'domains',
                        type: addParams.type === 'edit' ? 'string' : 'list',
                        label: 'Domains',
                        settings: {
                            errTipContent: 'Not valid Domain',
                            parentElement: addParams.type === 'edit' ? '.param-control' : '.form-inline',
                            successTipContent: addParams.type === 'edit' ? 'Valid Domain' : 'Valid Domain (Press Space key to complete.)',
                            validation: true,
                            validationType: 'domain',
                            validationOnTyping: true,
                            placeholder: 'Type and press space'
                        }
                    },
                    {
                        id: 'nicknames',
                        type: addParams.type === 'edit' ? 'string' : 'list',
                        label: 'Nicknames'
                    },
                    {
                        id: 'comment',
                        type: 'text',
                        label: 'Comment (optional)',
                        paramClass: 'text-param-average'
                    },
                    {
                        id: 'ignoring_spf_check',
                        type: 'boolean',
                        rightLabel: 'Ignore SPF check',
                        emptyLabel: true
                    },
                    {
                        id: 'dismiss_all_relevant_security_events',
                        type: 'boolean',
                        rightLabel: 'Dismiss all relevant security events',
                        emptyLabel: true,
                        data: true
                    }
                ];
                if (addParams && addParams.message) {
                    modalParams.unshift({
                        type: 'message',
                        message: addParams.message,
                        paramClass: 'full-width-param'
                    });
                }
                if (addParams && addParams.defaultData) {
                    _(modalParams).each(function (param) {
                        if (param.id === 'emails' && addParams.defaultData.from_email) {
                            if (addParams.type === 'edit') {
                                param.data = addParams.defaultData.from_email;
                            } else {
                                param.data = [addParams.defaultData.from_email];
                            }
                        } else if (param.id === 'ips' && addParams.defaultData.sender_ip) {
                            if (addParams.type === 'edit') {
                                param.data = addParams.defaultData.sender_ip;
                            } else {
                                param.data = [addParams.defaultData.sender_ip];
                            }
                        } else if (param.id === 'domains' && addParams.defaultData.from_domain) {
                            if (addParams.type === 'edit') {
                                param.data = addParams.defaultData.from_domain;
                            } else {
                                param.data = [addParams.defaultData.from_domain];
                            }
                        } else if (param.id === 'nicknames' && addParams.defaultData.nickname) {
                            if (addParams.type === 'edit') {
                                param.data = addParams.defaultData.nickname;
                            } else {
                                param.data = [addParams.defaultData.nickname];
                            }
                        } else if (param.id === 'comment' && addParams.defaultData.comment) {
                            param.data = addParams.defaultData.comment;
                        } else if (param.id === 'ignoring_spf_check' && addParams.defaultData.ignoring_spf_check) {
                            param.data = addParams.defaultData.ignoring_spf_check;
                        }
                    });
                }
                return modals.params([{
                        lastPage: true,
                        params: modalParams
                    }], modalTitle).then(function (data) {
                    if (addParams && addParams.entityId) {
                        data.entity_id = addParams.entityId;
                    }
                    if (addParams && addParams.entityType) {
                        data.entity_type = addParams.entityType;
                    }
                    if (data.emails || data.ips || data.domains || data.nicknames) {
                        if (addParams && addParams.loadFn && _(addParams.loadFn).isFunction()) {
                            addParams.loadFn();
                        }
                        if (addParams && addParams.afterLoadFn && _(addParams.afterLoadFn).isFunction()) {
                            data.afterLoadFn = addParams.afterLoadFn;
                        }
                        return apAvananExceptionsParams.saveException(data, addParams.type);
                    } else {
                        addParams.message = 'Please fill out one of 4 input boxes at least!';
                        return apAvananExceptionsParams.addDialogForAllType(addParams, title);
                    }
                });
            },
            saveException: function (data, type) {
                var p;
                var afterLoadFn;
                if (data.afterLoadFn) {
                    afterLoadFn = angular.copy(data.afterLoadFn);
                    data.afterLoadFn = undefined;
                }
                if (type === 'edit') {
                    p = apAvananExceptionsDao.edit(data);
                } else {
                    p = apAvananExceptionsDao.add(data);
                }
                return p.then(function (response) {
                    if (afterLoadFn && _(afterLoadFn).isFunction()) {
                        afterLoadFn();
                    }
                    return response;
                }, function (error) {
                    var alertText = 'Error saving exception for ';
                    if (feature.checkpointTheme) {
                        alertText += brandInfo.getAppName('Smart-Phish', 'checkpointTheme');
                    } else if (feature.sonicwallTheme) {
                        alertText += brandInfo.getAppName('Smart-Phish', 'sonicwallTheme');
                    } else {
                        alertText += 'Smart-Phish';
                    }
                    return modals.alert(alertText, { title: 'Error' }).then(function () {
                        return $q.reject(error);
                    }, function () {
                        return $q.reject(error);
                    });
                });
            }
        };
        return apAvananExceptionsParams;
    }]);
}());